import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Card, Modal, Button, Input } from 'antd';
import { updateRequestProperties, submitData } from 'modules/userrequest';

class SpecificConditions extends React.Component {
  state = {
    visible: false,
    specificConditions: '',
  };

  closeModal = () => this.setState({ visible: false });

  openModal = () => {
    const {
      userrequest: {
        properties: { specificConditions = '' },
      },
    } = this.props;

    // Update textarea value from props, and show modal
    this.setState({
      visible: true,
      specificConditions,
    });
  };

  saveForm = () => {
    const {
      userrequest,
      userrequest: { state, properties: prevProperties },
    } = this.props;

    const { specificConditions } = this.state;

    const data = {
      ...userrequest,
      properties: {
        ...prevProperties,
        specificConditions,
      },
    };

    // Save new properties value in global storage & serverside
    this.props.updateRequestProperties(data.properties);
    this.props.submitData({ data, state });

    this.closeModal();
  }

  handleValueChange = field =>
    ({ target: { value } = {} } = {}) => this.setState({ [field]: value });

  render () {
    const { visible, specificConditions } = this.state;

    return (
      <Card
        className="no-print"
        title="Prescriptions techniques particulières"
      >
        <Button onClick={this.openModal}>Renseigner</Button>

        <Modal
          title="Prescriptions techniques particulières"
          visible={visible}
          onOk={this.saveForm}
          onCancel={this.closeModal}
          destroyOnClose
        >
          <Input.TextArea
            value={specificConditions}
            onChange={this.handleValueChange('specificConditions')}
          />
        </Modal>
      </Card>
    );
  }
}

const mapStateToProps = ({ userrequest }) => ({ userrequest });

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    updateRequestProperties,
    submitData,
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SpecificConditions);



// WEBPACK FOOTER //
// ./src/components/Userrequest/SpecificConditions.js